import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper";
import "swiper/scss";
import "swiper/scss/autoplay";
import SwiperButton from "@components/button/SwiperButton";
import { HiPause, HiPlay } from "react-icons/hi2";
import useIsRTL from "@hooks/useIsRTL";
import cn from "classnames";
const HomeHeroCarousel = ({ items, onSlideChange }) => {
    const [swiper, setSwiper] = useState(null);
    const [isPaused, setIsPaused] = useState(false);
    const { isRtl, htmlDirIsChecked } = useIsRTL();
    const slidesClipStyle = () => {
        if (items.length >= 4) {
            return "--max-slides";
        }
        if (items.length === 3) {
            return "--default-slides";
        }
        if (items.length <= 2) {
            return "--min-slides";
        }
        return "--default-slides";
    };
    useEffect(() => {
        if (swiper) {
            isPaused ? swiper.autoplay.stop() : swiper.autoplay.start();
        }
    }, [isPaused]);
    return (_jsx("div", { className: "hero-desktop thumbs-wrapper", children: htmlDirIsChecked && (_jsxs(_Fragment, { children: [_jsxs("div", { className: "flex gap-4", children: [_jsx(SwiperButton, { isNext: false, swiper: swiper }), _jsx(Swiper, { dir: isRtl ? "rtl" : "ltr", autoplay: { delay: 7000 }, modules: [Autoplay], loop: true, slidesPerView: items.length > 4 ? 4 : items.length, spaceBetween: 8, onSlideChangeTransitionStart: (item) => onSlideChange(item.realIndex), onSwiper: setSwiper, watchOverflow: true, observer: true, className: cn("w-full", { [`swiper${slidesClipStyle()}`]: true }), children: items.map((x, i) => (_jsx(SwiperSlide, { children: _jsx("div", { className: "flex h-20 w-[140px]", children: _jsx("img", { className: "h-full w-full object-cover", src: x.thumbnailImageURL, alt: x.imageAltText }) }) }, i))) }), _jsx(SwiperButton, { isNext: true, swiper: swiper, className: "z-10 -ml-16 rtl:-mr-16 rtl:ml-0" })] }), _jsx("div", { className: "ml-[3.75rem] mr-[3.75rem] mt-4 cursor-pointer", children: isPaused ? (_jsx(HiPlay, { onClick: () => {
                            setIsPaused(!isPaused);
                        }, className: "h-6 w-6 rtl:rotate-180" })) : (_jsx(HiPause, { onClick: () => {
                            setIsPaused(!isPaused);
                        }, className: "h-6 w-6 rtl:rotate-180" })) })] })) }));
};
export default HomeHeroCarousel;
